import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import FleximodoParkinglocationsModel from './FleximodoParkinglocationsModel';
import ParkinglocationModel from './ParkinglocationModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/fleximodo/sensors';

export default new class FleximodoSensorsModel {

  constructor() { }

  get(serialNumber) {
    return new Promise((resolve, reject) => {
      this.getAll()
        .then((data) => {
          resolve(_.find(data, { serialNumber: serialNumber }));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getAll(fleximodoParkingLocationID = null) {
    var filter = {};
    if (fleximodoParkingLocationID) {
      filter = _.merge(filter, { locationId: fleximodoParkingLocationID });
    }
    return new Promise((resolve, reject) => {
      axios.get(BASE, {
        params: {
          access_token: UserModel.getAccessToken(),
          filter: filter
        }
      })
        .then((response) => {
          Promise.all([FleximodoParkinglocationsModel.getAll(), ParkinglocationModel.getAll(true)])
            .then((r) => {
              let fleximodoParkingLocations = r[0];
              let parkingLocations = r[1];
              let data = [];
              response.data.map(async (child, idx) => {
                let fLocation = _.find(fleximodoParkingLocations, { _id: child.locationId });
                if (!fLocation || fLocation === undefined) {
                  data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                } else {
                  let location = _.find(parkingLocations, { id: fLocation.corelocationId });
                  location
                    ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                    : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                }
              });
              resolve(data);
            });
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  create(data) {
    return new Promise((resolve, reject) => {
      axios.post(BASE, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  remove(serialNumber) {
    return new Promise((resolve, reject) => {
      axios.delete(BASE + '/' + serialNumber, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  update(serialNumber, data) {
    return new Promise((resolve, reject) => {
      axios.put(BASE + '/' + serialNumber, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  patch(serialNumber, data) {
    return new Promise((resolve, reject) => {
      axios.patch(BASE + '/' + serialNumber, data, {
        params: {
          access_token: UserModel.getAccessToken()
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

}


// WEBPACK FOOTER //
// ./src/components/FleximodoSensorsModel.js